import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "linkit_token";

export const linkitApi = axios.create({ baseURL: `${API}/linkit` });

linkitApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function resolveImg(url) {
  if (!url) return "";
  if (/^(https?:|blob:|data:)/.test(url)) return url;
  return `${BACKEND_URL}${url}`;
}

export async function uploadLinkitImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await linkitApi.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return `${BACKEND_URL}${data.url}`;
}

// Fetch a profile picture from a social/profile URL (best-effort). Returns a hosted URL.
export async function resolveSocialAvatar(url) {
  const { data } = await linkitApi.post("/resolve-avatar", { url });
  return `${BACKEND_URL}${data.avatar_url}`;
}
